import type { WidgetTableProps } from '@/components/WidgetTable/types';
import { RelativeTimeWithTooltip } from '@/components/shared/RelativeTimeWithTooltip';

export type ShadowAiUserBrowserTool = {
  id: string;
  domain: string;
  name: string;
  category: string;
  lastSeenAt: string;
};

export const COLUMNS: WidgetTableProps<ShadowAiUserBrowserTool>['columns'] = [
  {
    // Plain text (KIR-3813): the domain must not navigate off-app.
    header: 'URL',
    id: 'domain',
    cell: tool => (
      <span className="text-sm font-mono text-muted-foreground">
        {tool.domain}
      </span>
    ),
  },
  {
    header: 'Name',
    id: 'name',
    cell: tool => tool.name,
  },
  {
    header: 'Category',
    id: 'category',
    cell: tool => tool.category,
  },
  {
    header: 'Last Seen',
    id: 'lastSeen',
    cell: tool => <RelativeTimeWithTooltip date={tool.lastSeenAt} />,
  },
];
